export default __webpack_public_path__ + "static/media/recphilly.5774ee99.jpg";